import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});

export const initKeycloak = () => {
  const kcInit = keycloak.init({
    onLoad: 'check-sso',
    pkceMethod: 'S256',
    silentCheckSsoRedirectUri:
      window.location.origin + '/silent-check-sso.html',
    checkLoginIframe: false,
  });

  const timeout = new Promise<boolean>((resolve) =>
    setTimeout(() => resolve(false), 5000),
  );

  return Promise.race([kcInit, timeout]);
};

export const getKeycloakToken = async () => {
  if (!keycloak.authenticated) {
    await keycloak.login({ redirectUri: window.location.href });
    return null;
  }

  await keycloak.updateToken(10);
  return keycloak.token ?? null;
};

export default keycloak;
